import {IService} from "@/model/Service/Service"

export interface IHasService {
    getService(): IService | null
    setService(service: IService): void
}

function hasService<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasService {
        private service: IService | null = null
        
        constructor(...args: any[]) {
            super(...args);
        }

        public getService(): IService | null {
            return this.service
        }
        public setService(service: IService): void {
            this.service = service
        }
    };
}

export default hasService